var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ya-te-note text-left text-sm-center co-text-gray-3 co-py-8 co-px-16 co-px-sm-0"},[_vm._v("※LINEヤフーテックアカデミーはLINEヤフーとテックアカデミー（キラメックス社運営）が共同開発・運営するプログラミングスクールです")])
}
var staticRenderFns = []

export { render, staticRenderFns }